var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{class:_vm.b(),attrs:{"value":_vm.parsedValue},on:{"change":_vm.onInputViewMode}},_vm._l((_vm.items),function(item){return _c('v-btn',{key:item.value,attrs:{"text":""}},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }